import React from "react";
import { Link } from "react-router-dom";
import useLandingTheme from "./useLandingTheme";

// Call-to-action link used across the landing sections.
// `onDark` is for buttons on a panel that stays dark in both themes
// (kk-dark-section). Light mode remaps tw-bg-[#FF43A7] to violet globally,
// which would put midnight text on violet, so those use a white fill instead.
export default function LandingButton({ to, variant = "primary", onDark = false, className = "", children }) {
  const { isLight, focusRing } = useLandingTheme();
  const light = isLight && !onDark;

  const variants = {
    primary: light
      ? "tw-bg-[#712CB0] tw-text-white hover:tw-bg-[#5E2494]"
      : isLight
        ? "tw-bg-white tw-text-[#1E0039] hover:tw-bg-[#F3E8FF]"
        : "tw-bg-[#FF43A7] tw-text-midnight hover:tw-bg-[#FF6BB9]",
    secondary: light
      ? "tw-border tw-border-solid tw-border-[#712CB0] tw-bg-transparent tw-text-[#712CB0] hover:tw-bg-[#712CB0]/10"
      : "tw-border tw-border-solid tw-border-white/30 tw-bg-transparent tw-text-white hover:tw-bg-white/10",
  };

  return (
    <Link
      to={to}
      className={`tw-inline-flex tw-min-h-[48px] tw-items-center tw-justify-center tw-rounded-xl tw-px-7 tw-py-3 tw-text-base tw-font-bold tw-no-underline tw-transition-colors tw-duration-200 ${variants[variant]} ${focusRing} ${className}`}
    >
      {children}
    </Link>
  );
}
